// eslint-disable-next-line import/prefer-default-export
var blockNonDigits = function blockNonDigits(event) {
  var keyNav = /backspace|delete|arrowRight|arrowLeft|tab/i;

  if (event.key.match(/\D/) && !event.key.match(keyNav) && !event.metaKey && !event.ctrlKey) {
    event.preventDefault();
  }
};

export { blockNonDigits };
